import { render, staticRenderFns } from "./SubProductFeedback.vue?vue&type=template&id=ad9d0298&"
import script from "./SubProductFeedback.vue?vue&type=script&lang=js&"
export * from "./SubProductFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports